var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgOrologio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-clock-2491057",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_979",
    "data-name": "Rettangolo 979",
    width: 14,
    height: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9558",
    "data-name": "Tracciato 9558",
    d: "M17.289,8.591a6.159,6.159,0,0,0-8.7.014A6.151,6.151,0,0,0,17.3,17.289a6.125,6.125,0,0,0-.014-8.7ZM12.94,18.014a5.074,5.074,0,1,1,5.074-5.074A5.077,5.077,0,0,1,12.94,18.014Z",
    transform: "translate(-5.833 -6.047)",
    fill: "#255300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9559",
    "data-name": "Tracciato 9559",
    d: "M47.28,30.7l.014-2.658a.54.54,0,0,0-.54-.54h0a.54.54,0,0,0-.54.54l-.014,2.9V31.1c0,.014,0,.014.014.028s0,.014.014.028,0,.014.014.028.014.014.014.028.014.014.014.028.014.014.014.028l.014.014c0,.014.014.014.014.028l.014.014.014.014.014.014.014.014,2.558,2.388a.5.5,0,0,0,.37.142.561.561,0,0,0,.4-.171.537.537,0,0,0-.028-.753Z",
    transform: "translate(-39.633 -23.805)",
    fill: "#255300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgOrologio);
export default __webpack_public_path__ + "static/media/SvgOrologio.07607cb045855050a1d41fa75253aa66.svg";
export { ForwardRef as ReactComponent };